<template>
    <div>
        <div v-for="(v, index) of $v.attributeValues.$each.$iter" :key="index" class="input-group mb-3">
            <input type="text" class="form-control" placeholder="Attribute value"
                   :class="{'is-invalid': v.$error}" v-model.trim="v.text.$model" @input="updateAttributeLines">
            <div class="input-group-append">
                <button class="btn btn-outline-danger" type="button" @click="removeNewVariant(index)">Del</button>
            </div>
            <span class="invalid-feedback" v-if="!v.text.required">Attribute value is required</span>
        </div>

        <button class="btn btn-outline-info" type="button" @click="addNewVariant">Add new...</button>

        <div class="d-inline-block ml-2">
            <span class="custom-validation-message" v-if="!$v.attributeValues.minLength">Attribute values list must have at least {{ $v.attributeValues.$params.minLength.min }} elements.</span>
            <span class="custom-validation-message" v-else-if="!$v.attributeValues.required">Attribute values list must not be empty.</span>
            <span class="custom-validation-message" v-else-if="$v.attributeValues.$error">Attribute values list is invalid.</span>
        </div>

    </div>
</template>

<script lang="ts">
    import {Component, Vue} from "vue-property-decorator";
    import {minLength, required} from 'vuelidate/lib/validators';

    @Component
    export default class AppMultipleAttributeLines extends Vue{
        private attributeValues: { text: string }[] = [{text: ''}, {text: ''}];

        validations() {
            return {
                attributeValues: {
                    required,
                    minLength: minLength(2),
                    $each: {
                        text: {
                            required,
                        },
                    },
                }
            };
        }

        addNewVariant(): void {
            this.attributeValues.push({text: ''});
            this.updateAttributeLines();
        }

        removeNewVariant(index: number): void {
            this.attributeValues.splice(index, 1);
            this.updateAttributeLines();
        }

        updateAttributeLines() {
            this.$emit('input', this.attributeValues);
        }

        mounted() {
            this.$events.on('validate', () => {
                this.$v.$touch();
                if (this.$v.$anyError) {
                    this.$events.emit('throwError');
                }
            });
        }

        beforeDestroy() {
            this.$events.off('validate');
        }
    }
</script>

<style scoped lang="scss">
    .custom-validation-message {
        width: 100%;
        margin-top: .25rem;
        font-size: 80%;
        color: #dc3545;
    }
</style>
